<template>
  <div
    class="cell"
    v-if="is_loading"
    :style="{ backgroundColor: backGround, borderRadius: `${borderRadius}px` }"
  >
    <i
      class="el-icon-loading"
      :style="{ color: fontColor, fontSize: `${fontSize * 2}px` }"
    ></i>
    <span :style="{ color: fontColor, fontSize: `${fontSize}px` }">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  name: "LoadingCell",
  props: {
    title: { type: String, default: "正在登录..." },
    is_loading: { type: Boolean, default: false },
    backGround: { type: String, default: "rgba(255,255,255,0.7)" },
    fontColor: { type: String, default: "rgba(47,117,251,1)" },
    fontSize: { type: Number, default: 14 },
    borderRadius: { type: Number, default: 14 },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.cell {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
}
.el-icon-loading{
margin-bottom: 8px;
}
</style>
